import { Injectable } from '@angular/core';
import { DynamicScriptLoaderService } from './dynamic-script-loader.service';
import { log } from '../functions';
import {InterfaceService} from './interface.service';
import {debounceTime, first} from 'rxjs/operators';
declare var lightGallery: any;
@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  public dynamicEl: any = [];
  private lightGallery: HTMLElement;
  public pluginLightGallery: any;
  constructor(
    public interfaceService: InterfaceService,
    public dynamicScriptLoaderService: DynamicScriptLoaderService
  ) {
    this.interfaceService.openChat$.pipe(first(), debounceTime(1000)).subscribe(() => {
      this.loadAssets();
    });
    this.interfaceService.openChat$.subscribe((event) => {
      this.clear('openChat$');
    });
  }
  loadAssets() {
    this.dynamicScriptLoaderService.loadStyle('/assets/js/lightgallery/css/lightgallery.min.css', 'fancybox');
    this.dynamicScriptLoaderService.load(['lightgallery']).then(() => {
      this.dynamicScriptLoaderService
        .load(['lg-thumbnail', 'lg-zoom', 'lg-rotate', 'lg-fullscreen', 'lg-video'])
        .then();
      this.lightGallery = document.getElementsByTagName('body')[0];
    });
  }
  addToGallery(attachment, text = '') {
    let index = this.dynamicEl.findIndex((v) => v.file_uri === attachment.file_uri || v.file_uri === attachment.player);
    if (index === -1 && (attachment?.file_uri || attachment.player)) {
      index = this.dynamicEl?.length;
      const data: any = {
        downloadUrl: attachment?.file_uri + '&download=true',
        subHtml: text,
        file_uri: attachment?.file_uri || attachment.player
      };
      if (attachment.type === 'video' || attachment.type === 'animation') {
        data.html = `<video class="lg-video-object lg-html5" controls preload="true"><source src="${attachment?.file_uri}" type="${attachment?.mime_type}">Your browser does not support HTML5 video</video>`;
        data.thumb = '/assets/images/video.svg';
      } else if (attachment.type === 'video_iframe') {
        data.html = `<iframe  class="lg-video-object lg-html5" src="${attachment.player}" frameborder="0"></iframe>`;
        data.thumb = attachment?.thumb?.file_uri || '/assets/images/video.svg';
      } else {
        data.src = attachment?.file_uri;
        data.thumb = attachment?.thumb?.file_uri || '/assets/images/logo.png';
      }
      this.dynamicEl.push(data);
    }
    return index;
  }
  openGallery(event, fileUri): void {
    if (event) {event.preventDefault(); }
    const index = this.dynamicEl.findIndex((v) => v.file_uri === fileUri);
    if (index === -1) {
      // TODO chat scroll
      console.error('No find photo', this.dynamicEl);
      return;
    }
    try {
      this.pluginLightGallery = lightGallery(this.lightGallery, {
        index,
        thumbnail: true,
        dynamic: true,
        dynamicEl: this.dynamicEl,
        download: true,
        touch: false,
        clickSlide: false,
        clickOutside: false,
        // plugins: [lgThumbnail],
        onUpdate: () => {
          /// alert('!');
        }
      });
    }catch (e) {
      console.error(e);
      this.loadAssets();
    }
  }
  openGallerySingle(thumb: string, src: string): void {
    if (!thumb) { return; }
    this.pluginLightGallery = lightGallery(this.lightGallery, {
      thumbnail: false,
      dynamic: true,
      download: true,
      dynamicEl: [
        {
          src: src || thumb,
          thumb: thumb || src
        }
      ],
      touch: {
        vertical: false
      }
      // plugins: [lgThumbnail],
    });
  }
  clear(logStr = ''): void {
    log('lightGallery clear witch', logStr);
    this.dynamicEl = [];
  }
}
